import baseApi from "./base"
import { Apply1Request, Apply1Response, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { BaseResponse } from "./types/common"
import { GetCaptchaResponse, GetCaptchaRequest } from "./types/captcha"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request } from "./types/apply3"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "SPE0018",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptchaResponse, GetCaptchaRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          functionCode: "SPE0018",
          NextTransactionUrl: "Facebook/KrediKartiIssizlikSigortasiLead/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptchaResponse, GetCaptchaRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          functionCode: "SPE0018",
          NextTransactionUrl: "Facebook/KrediKartiIssizlikSigortasiLead/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          cepTel: body.cepTel,
          dogumYil: body.dogumYil,
          dogumAy: body.dogumAy,
          dogumGun: body.dogumGun,
          captcha: body.captcha,
          cid: body.cid,
          kvkk: body.kvkk,
          etk: body.etk,
          functionCode: "SPE0018",
          NextTransactionUrl: "Facebook/KrediKartiIssizlikSigortasiLead/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<BaseResponse, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})
export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation } = api

export default api
